module.exports = __webpack_public_path__ + "media/feature-icons/Barcode_Scanning-6e6a25ff.svg";